import api from "@/plugins/api";

export const fetchMyRecipes = async (
  { commit },
  params = {
    next_page: 1,
    last_page: 1,
    per_page: 4,
    total: 0
  }
) => {
  const response = await api({
    method: "POST",
    endpoint: "recipes",
    body: {
      pagination: params
    }
  });

  const { data } = response;

  if (params.next_page === 1) {
    commit("resetMyRecipes");
  }

  commit("allRecipesMutation", data);
};
